import type { ReactNode } from "react";
import type { BlogPostSummary } from "@/lib/blog";
import { NewsletterSignup } from "@/components/newsletter/NewsletterSignup";
import { ClientShowcase } from "./ClientShowcase";
import { CtaBand } from "./CtaBand";
import { HomeSectionReveal } from "./HomeSectionReveal";
import { LatestNews } from "./LatestNews";
import { Operations } from "./Operations";
import { ProductLineup } from "./ProductLineup";
import { SiteFooter } from "./SiteFooter";
import { SiteHeader } from "./SiteHeader";
import { SocialProof } from "./SocialProof";
import { StbEcosystem } from "./StbEcosystem";
import { WorldwideDelivery } from "./WorldwideDelivery";

export function HomeExperience({
  hero,
  latestPosts,
}: {
  hero: ReactNode;
  latestPosts: BlogPostSummary[];
}) {
  return (
    <div data-home-page className="min-h-screen overflow-x-clip bg-background text-foreground">
      <noscript>
        <style>{`[data-home-reveal] { opacity: 1 !important; transform: none !important; animation: none !important; }`}</style>
      </noscript>
      <SiteHeader homeGlass />
      <main>
        {hero}
        <HomeSectionReveal>
          <SocialProof />
        </HomeSectionReveal>
        <HomeSectionReveal>
          <ProductLineup />
        </HomeSectionReveal>
        <HomeSectionReveal>
          <StbEcosystem />
        </HomeSectionReveal>
        <HomeSectionReveal>
          <ClientShowcase />
        </HomeSectionReveal>
        <HomeSectionReveal>
          <Operations />
        </HomeSectionReveal>
        <HomeSectionReveal>
          <WorldwideDelivery />
        </HomeSectionReveal>
        <HomeSectionReveal>
          <LatestNews posts={latestPosts} />
        </HomeSectionReveal>
        <HomeSectionReveal>
          <NewsletterSignup source="homepage-news" variant="home" />
        </HomeSectionReveal>
        <HomeSectionReveal>
          <CtaBand />
        </HomeSectionReveal>
      </main>
      <SiteFooter />
    </div>
  );
}
